import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Status } from '../models/status-model';

@Injectable({
    providedIn: 'root'
})
export class StatusService {

    private API_STATUS_URL = environment.ipserver + 'o2c-backend/private/invoices/listStatus';

    constructor(
        private httpClient: HttpClient
    ) { }

    /**
     * Method that obtains a list of divisions by calling status rest service
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2019-12-11
     * @return Observable with a json that contains a list of status
     */
    public getStatus(): Observable<Status[]> {
        return this.httpClient.get <Status[]>(this.API_STATUS_URL);
    }
}
